export const waitTimeRateList = (state) => state.waitTimeRateList;
